import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/dashboard.service';
import { DashBoardCustomerOrderStatus, DashBoardOrderStatus, DashBoardProduct } from 'src/app/Enums/dashboard';
import { CustomerOrderStatus } from 'src/app/Enums/order';
import { roles } from 'src/app/Enums/roles';
import { DashBoard, DashBoardLatestOrders } from 'src/app/models/dashboard/dashboard.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  LoaderAdminEarning: boolean = false;
  LoaderAdminOrderTotal: boolean = false;
  LoaderAdminProductTotal: boolean = false;
  LoaderActiveProductsTotal: boolean = false;
  LoaderInActiveProductsTotal: boolean = false;
  LoaderCatergoiesTotal: boolean = false;
  LoaderTotalAmountSpend: boolean = false;
  LoaderOrdersTotal: boolean = false;
  orderStatusPadding: boolean = false;
  orderStatusConfirm: boolean = false;
  orderStatusDelivered: boolean = false;
  orderStatusDispatched: boolean = false;
  adminOrderStatusPending: boolean = false;
  adminOrderStatusConfirm: boolean = false;
  adminOrderStatusDelivered: boolean = false;
  adminOrderStatusDispatched: boolean = false;
  adminLatestOrder: boolean = false;
  customerLatestOrder: boolean = false;
  customerWarranty: boolean = false;
  adminWarranty: boolean = false;
  totalOrder: number;
  totalAmountSpend: number;
  totalOrderStatus: string;
  orderStatusModel: number;
  userRole: string;
  totalActiveProducts: number;
  totalInActiveProducts: number;
  totalCategory: number;
  totalAdminOrder: number;
  totalAdminEarning: number;
  totalAdminOrderStatus: string;
  custometTotalOrderStatus: string;
  totalAdminWarranty: string;
  totalACustomerWarranty: string;
  getLatestOrder: DashBoardLatestOrders;
  orderStatus: DashBoardCustomerOrderStatus;
  orderCount: DashBoardCustomerOrderStatus;
  dashBoardOrderStatus: typeof DashBoardOrderStatus = DashBoardOrderStatus;
  orderStatusVm: DashBoard;
  pending: any;
  confirm: any;
  dispatched: any;
  delivered: any;


  constructor(private _localStorageService: LocalstorageService, private router:Router,private dashboard: DashboardService, private alertify: AlertifyService,) {
    this.userRole = LocalstorageService.getUserRole();
    this._localStorageService.setMenu("1");
    this.orderStatus = new DashBoardCustomerOrderStatus();
  }

  ngOnInit() {
    if (localStorage.getItem('role') == roles.Admin.toString()) {
      this.getAdminOrderTotal();
      this.getAdminEarning();
      this.getAdminOrderStatus("0");
      this.getAdminOrderStatus("1");
      this.getAdminOrderStatus("2");
      this.getAdminOrderStatus("3");
      this.getActiveProductsTotal();
      this.getCatergoiesTotal();
      this.getLatestOrdersAdmin();
      this.getAdminWarrantyTotal();
      this.getInActiveProductsTotal();
      this.getAdminProductsTotal()
    } else {
      this.getOrdersTotal();
      this.getTotalAmountSpend();
      this.getTotalOrderStatus("0");
      this.getTotalOrderStatus("1");
      this.getTotalOrderStatus("2");
      this.getTotalOrderStatus("3");
      this.getLatestOrdersCustomer();
      this.getCustomerWarrantyTotal();
    }
  }

  getOrdersTotal() {
    this.LoaderOrdersTotal = true;
    this.dashboard.GetOrdersTotal().subscribe((response) => {
      var responseBody = JSON.parse(response._body);
       this.totalOrder = responseBody.responseData;
       this.LoaderOrdersTotal = false;
       (err) => {
        this.LoaderOrdersTotal = false;
      }
    })
  }

  getTotalAmountSpend() {
    this.LoaderTotalAmountSpend = true;
    this.dashboard.GetTotalAmountSpend().subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.totalAmountSpend = responseBody.responseData;
      this.LoaderTotalAmountSpend = false;
      (err) => {
        this.LoaderTotalAmountSpend = false;
      }
    })
  }

  getTotalOrderStatus(orderStatus: string) {
    if (orderStatus == "0") {
      this.orderStatusPadding = true;
    }
    if (orderStatus == "1") {
      this.orderStatusConfirm = true;
    }
    if (orderStatus == "2") {
      this.orderStatusDelivered = true;
    }
    if (orderStatus == "3") {
      this.orderStatusDispatched = true;
    }
    var order = new DashBoard();
    order.OrderStatus = orderStatus;
    this.dashboard.GetTotalOrderStatus(order)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.orderStatus = responseBody.responseData;
          if (orderStatus == "0") {
            this.pending = this.orderStatus;
            this.orderStatusPadding = false;
          }
          if (orderStatus == "1") {
            this.confirm = this.orderStatus;
            this.orderStatusConfirm = false;
          }
          if (orderStatus == "2") {
            this.delivered = this.orderStatus;
            this.orderStatusDelivered = false;
          }
          if (orderStatus == "3") {
            this.dispatched = this.orderStatus;
            this.orderStatusDispatched = false;
          }
        } (err) => {
        }
      });
  }

  getAdminProductsTotal() {
    this.LoaderAdminOrderTotal = true;
    this.dashboard.GetAdminProductTotal().subscribe((response) => {  
      var responseBody = JSON.parse(response._body);
      this.totalAdminOrder = responseBody.responseData;
      this.LoaderAdminOrderTotal = false;
      (err) => {
        this.LoaderAdminOrderTotal = false;
      }
    })
  }

  getActiveProductsTotal() {
    this.LoaderActiveProductsTotal = true;
    this.dashboard.GetActiveProductsTotal().subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.totalActiveProducts = responseBody.responseData;
      this.LoaderActiveProductsTotal = false;
      (err) => {
        this.LoaderActiveProductsTotal = false;
      }
    })
  }

  getInActiveProductsTotal() {
    this.LoaderInActiveProductsTotal = true;
    this.dashboard.GetInActiveProductsTotal().subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.totalInActiveProducts = responseBody.responseData;
      this.LoaderInActiveProductsTotal = false;
      (err) => {
        this.LoaderInActiveProductsTotal = false;
      }
    })
  }

  getCatergoiesTotal() {
    this.LoaderCatergoiesTotal = true;
    this.dashboard.GetCategoryTotal().subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.totalCategory = responseBody.responseData;
      this.LoaderCatergoiesTotal = false;
      (err) => {
        this.LoaderCatergoiesTotal = false;
      }
    })
  }

  getAdminOrderTotal() {
    this.LoaderAdminOrderTotal = true;
    this.dashboard.GetAdminOrderTotal().subscribe((response) => {  
      var responseBody = JSON.parse(response._body);
      this.totalAdminOrder = responseBody.responseData;
      this.LoaderAdminOrderTotal = false;
      (err) => {
        this.LoaderAdminOrderTotal = false;
      }
    })
  }

  getAdminEarning() {
    this.LoaderAdminEarning = true;
    this.dashboard.GetAdminEarning().subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.totalAdminEarning = responseBody.responseData;
      this.LoaderAdminEarning = false;
      (err) => {
        this.LoaderAdminEarning = false;
      }
    })
  }

  getAdminOrderStatus(orderStatus: string) {
    if (orderStatus == "0") {
      this.adminOrderStatusPending = true;
    }
    if (orderStatus == "1") {
      this.adminOrderStatusConfirm = true;
    }
    if (orderStatus == "2") {
      this.adminOrderStatusDelivered = true;
    }
    if (orderStatus == "3") {
      this.adminOrderStatusDispatched = true;
    }
    var order = new DashBoard();
    order.OrderStatus = orderStatus;
    this.dashboard.GetAdminOrderStatus(order)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.orderStatus = responseBody.responseData;
          if (orderStatus == "0") {
            this.pending = this.orderStatus;
            this.adminOrderStatusPending = false;
          }
          if (orderStatus == "1") {
            this.confirm = this.orderStatus;
            this.adminOrderStatusConfirm = false;
          }
          if (orderStatus == "2") {
            this.delivered = this.orderStatus;
            this.adminOrderStatusDelivered = false;
          }
          if (orderStatus == "3") {
            this.dispatched = this.orderStatus;
            this.adminOrderStatusDispatched = false;
          }
        } (err) => {
        }
      });
  }

  getLatestOrdersAdmin() {
    this.adminLatestOrder = true;
    this.dashboard.getLatestOrdersAdmin().subscribe(response => {
      var responseBody = JSON.parse(response._body);
        this.getLatestOrder = responseBody.responseData;
        this.adminLatestOrder = false;
        (err) => {
          this.adminLatestOrder = false;
        }
      
    });
  }

  getLatestOrdersCustomer() {
    this.customerLatestOrder = true;
    this.dashboard.getLatestOrdersCustomer().subscribe(response => {
      var responseBody = JSON.parse(response._body);
        this.getLatestOrder = responseBody.responseData;
        this.customerLatestOrder = false;
        (err) => {
          this.customerLatestOrder = false;
        }
      
    });
  }

  getAdminWarrantyTotal() {
    this.adminWarranty = true;
    this.dashboard.GetAdminWarrantyTotal().subscribe((response) => {  
      var responseBody = JSON.parse(response._body);
      this.totalAdminWarranty = responseBody.responseData;
      this.adminWarranty = false;
      (err) => {
        this.adminWarranty = false;
      }
    })
  }

  getCustomerWarrantyTotal() {
    this.customerWarranty = true;
    this.dashboard.GetCustomerWarrantyTotal().subscribe((response) => {  
      var responseBody = JSON.parse(response._body);
      this.totalACustomerWarranty = responseBody.responseData;
      this.customerWarranty = false;
      (err) => {
        this.customerWarranty = false;
      }
    })
  }

  viewOrderAdmin(item){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/admin-single-order-list/' + item.id]));
      window.open('#' + url, '_blank');
      this._localStorageService.setMenu("6");
  }

  viewCustomer(item) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/customer-single-order-list/' + item.id]));
      window.open('#' + url, '_blank');
      this._localStorageService.setMenu("3");
  }
}
